import { render } from "./home-view-el.vue?vue&type=template&id=06aff769"
import script from "./home-view-el.vue?vue&type=script&lang=js"
export * from "./home-view-el.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home-view/home-view-el/home-view-el.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06aff769"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06aff769', __exports__)) {
    api.reload('06aff769', __exports__)
  }
  
  module.hot.accept("./home-view-el.vue?vue&type=template&id=06aff769", () => {
    api.rerender('06aff769', render)
  })

}


export default __exports__